module.exports = __webpack_public_path__ + "static/media/bonus_gifts.60d91e44.svg";